import { render, staticRenderFns } from "./BestOfferConfigurationPreview.vue?vue&type=template&id=fa55b15c&scoped=true"
import script from "./BestOfferConfigurationPreview.vue?vue&type=script&lang=js"
export * from "./BestOfferConfigurationPreview.vue?vue&type=script&lang=js"
import style0 from "./BestOfferConfigurationPreview.vue?vue&type=style&index=0&id=fa55b15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa55b15c",
  null
  
)

export default component.exports